import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

type IndicatorIconProps = {
  isEnabled: boolean;
  className?: string;
};

export const IndicatorIcon = ({ isEnabled, className }: IndicatorIconProps) => {
  if (isEnabled) {
    return <CheckIcon className={className} color="success" />;
  } else {
    return <CloseIcon className={className} color="error" />;
  }
};
